<template>
  <FieldBox :title="title" class="profit-price">
    <PlusMinusInput
      v-model="profitTakerPrice"
      :precision="precision"
      :min="0"
      :max="999999999"
      :step="minTick"
      :match-tick="true"
      :match-precision="true"
    />
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import PlusMinusInput from 'com/PlusMinusInput'
import FieldBox from '../FieldBox'
import getPriceMinTick from 'utils/getPriceMinTick'
import getPriceAccuracy from 'utils/getPriceAccuracy'

export default {
  name: 'AttachProfitPriceField',
  components: {
    FieldBox,
    PlusMinusInput
  },
  props: {
    minTicks: Array
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    title() {
      return this.order.action === 'BUY'
        ? this.$t('trade.sell-limit')
        : this.$t('trade.buy-limit')
    },
    minTick() {
      return getPriceMinTick(this.profitTakerPrice, this.minTicks)
    },
    precision() {
      return getPriceAccuracy(this.minTick)
    },
    profitTakerPrice: {
      get() {
        return this.order.profitTakerPrice
      },
      set(price) {
        this.$store.dispatch('updateTradeOrder', {
          profitTakerPrice: price
        })
      }
    }
  }
}
</script>
